var map = {
	"./ab-modification-icon.svg": 98068,
	"./add-icon.svg": 24465,
	"./approve-icon.svg": 86979,
	"./checked-checkbox.svg": 65995,
	"./close-icon.svg": 45674,
	"./cross-icon.svg": 8750,
	"./deactivate-icon.svg": 25200,
	"./delta-negative.svg": 95118,
	"./delta-plus.svg": 86103,
	"./disabled-add-icon.svg": 89916,
	"./discard-icon.svg": 94572,
	"./ellipsis-button.svg": 19410,
	"./error-cross.svg": 86929,
	"./error-info-icon.svg": 19035,
	"./error-sign.svg": 19164,
	"./info-icon.svg": 68938,
	"./modal-close.svg": 94540,
	"./move-icon.svg": 71423,
	"./navigate-icon.svg": 91073,
	"./simple-modification-icon.svg": 45295,
	"./success-tick.svg": 10465,
	"./trash-icon.svg": 87668,
	"./unchecked-checkbox.svg": 93234
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 99742;